<template>
    <div class="vsl-row vsl-section-row">{{ text }}</div>
</template>

<script>
export default {
    name: "VSLSectionRowRenderer",
    props: {
        text: String
    }
}
</script>

<style scoped>
.vsl-section-row {
    background-color: #224460;
    color: #ffffff;
    font-weight: bold;
    font-size: 16px;
    padding: 8px;
    text-align: left;
}
</style>